(function () {
  /********************
   * START: settings
   ********************/
  const DEBUG = true;
  const DRY_RUN = false;
  const CUSTOM_EVENTS = {
    sh_sort_collection_items: {
      nativeEvent: "change",
      defaultSelector: "[data-trackid=sort_collection]",//メモ：buttonに追加
      targets: [
        {
          selector: "",
        },
      ],
      getCallback: makeSortCollectionItemsHandler,
    },
    sh_toggle_favorite: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=toggle_favorite]",
      targets: [
        {
          selector: "[data-block-type=buy-buttons] a.wishlist-btn",//メモ：商品ページ
          state: {
            attr: "data",
            key: "added",
          },
          datasetProductKey: "proid", // ハイフンは削除してキャメルケースに変換する, ex: data-wk-remove-product -> wkRemoveProduct
          datasetVariantKey: "varid", // ハイフンは削除してキャメルケースに変換する, ex: data-wk-remove-product -> wkRemoveProduct
        },
      ],
      getCallback: makeToggleFavoriteHandler,
    },
    sh_expand_thumbnail: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=expand_thumbnail]",//メモ：PCはdivに入れた。SPはbutton
      targets: [
        {
          selector: "",
        },
      ],
      getCallback: makeExpandThumbnailHandler,
    },
    sh_slide_thumbnail: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=slide_thumbnail]",//メモ：PCはサムネbuttonに入れた。SPなし
      targets: [
        {
          selector: "",
        },
      ],
      getCallback: makeSlideThumbnailHandler,
    },
    sh_open_hidden_content: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=open_hidden_content]",//メモ：<details>に入れた
      targets: [
        {
          selector: "",
          state: {
            attr: "aria",
            key: "true",//メモ：もとはexpanded
          },
        },
      ],
      getCallback: makeOpenHiddenContentHandler,
    },
    sh_launch_chat: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=launch_chat]",
      targets: [
        {
        // モーダル開いた後の、ターゲットになるセレクタ
	      selector: "[data-ch-testid=new-chat-button]",
	      nativeEvent: "click",
	      // モーダルを開くボタンのセレクタ
	      registerAfterEvent: {
	        selector: "#ch-plugin-launcher",
	        nativeEvent: "click",
        },
      },
    ],
      getCallback: makeLaunchChatHandler,
      delay: 3000,
    },
    sh_subscribe_email: {
      nativeEvent: "submit",
      defaultSelector: "[data-trackid=subscribe_email]", // nativeEventがsubmitの場合、form要素のセレクタを指定
      targets: [
        {
          // shopify form
          selector: "", // use defaultSelector
        },
        {
          // klaviyo email campaign
          selector: "[data-trackidwrap=subscribe_email] form button",//メモ：Klaviyoのdivにdataを設定
          nativeEvent: "", // naviveEventを上書き
          delay: 3000,
        },
      ],
      getCallback: makeSubscribeEmailHandler,
    },
    sh_click_cta: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=click_cta]",
      targets: [
        {
          selector: "",
        },
      ],
      getCallback: makeClickCTAHandler,
      once: true,
      delay: 3000,
    },
    sh_submit_cta: {
      nativeEvent: "submit",
      defaultSelector: "[data-trackid=submit_cta]",
      targets: [
        {
          selector: "", // form要素
        },
      ],
      getCallback: makeSubmitCTAHandler,
      delay: 3000,
      once: true,
    },
    sh_click_review_link: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=click_review_link]",//メモ：デフォルトのまま
      targets: [
        {
          selector: ".jdgm-preview-badge--with-link, .jdgm-histogram__row",
        },
      ],
      getCallback: makeClickReviewLinkHandler,
      delay: 2000,
    },
    sh_paginate_reviews: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=paginate_previews]",
      targets: [
        {
          selector: ".jdgm-paginate__page",
          datasetPageKey: "page",
        },
      ],
      getCallback: makePaginateReviewsHandler,
      reRegisterAfterEvent: true,
      delay: 2000,
    },
    sh_submit_review: {
      nativeEvent: "submit",
      defaultSelector: "[data-trackid=submit_review]",
      targets: [
        {
          selector: ".jdgm-form",
          observeMount: "#judgeme_product_reviews",
        },
      ],
      getCallback: makeSubmitReviewHandler,
      ratingFieldName: "score", // form内の rating情報が入っている name 属性名
    },
    sh_click_image_on_review: {
      nativeEvent: "click",
      defaultSelector: "[data-trackid=click_image_on_review]",
      targets: [
        {
          selector: ".jdgm-rev__pic-img, .jdgm-gallery__thumbnail",
        },
      ],
      getCallback: makeClickImageOnReviewHandler,
      delay: 2000,
    },
    sh_search_review: {
      nativeEvent: "blur",
      defaultSelector: "[data-trackid=search_review]",
      targets: [
        {
          selector: ".jdgm-review-search", // input要素
        },
      ],
      getCallback: makeSearchReviewHandler,
      delay: 2000,
    },
    sh_sort_review: {
      nativeEvent: "change",
      defaultSelector: "[data-trackid=sort_review]",
      targets: [
        {
          selector: ".jdgm-sort-dropdown",
        },
      ],
      getCallback: makeSortReviewHandler,
      delay: 2000,
    },
    sh_scroll_page: {
      nativeEvent: "scroll",
      getCallback: makeScrollPageHandler,
    },
  };

  /********************
   * START: variables
   ********************/

  const registeredHandlers = new Map();

  /********************
   * START: utils
   ********************/

  function getInnerContent(el) {
    const isChildImage =
      el.childElementCount === 1 &&
      el.firstElementChild instanceof HTMLImageElement;
    if (isChildImage) {
      return el.firstElementChild.alt;
    }
    return el.innerText?.trim();
  }

  /**
   * @param {HTMLElement} el
   */
  function findNearestScrollableParent(el) {
    if (!el) {
      return undefined;
    }

    let parent = el.parentElement;
    while (parent) {
      const { overflow } = window.getComputedStyle(parent);
      if (overflow.split(" ").every((o) => o === "auto" || o === "scroll")) {
        return parent;
      }
      parent = parent.parentElement;
    }

    return document.documentElement;
  }
  function measureElementScrollPosition(el) {
    const parent = findNearestScrollableParent(el);
    const pos = parent.scrollTop + el.getBoundingClientRect().y;
    const height = parent.scrollHeight;
    return Math.floor((pos / height) * 1000) / 10;
  }

  function findAllTargetElement(selector, shadowRootSelector) {
    if (!shadowRootSelector) {
      return document.querySelectorAll(selector);
    }
    const root = document.querySelector(shadowRootSelector);
    return "shadowRoot" in root && !!root.shadowRoot
      ? root.shadowRoot.querySelectorAll(selector)
      : [];
  }
  /**
   *
   * @param {Array<[string, any]>} arr
   * @returns {Record<string, any>}
   */
  function makeParams(arr) {
    if (!Array.isArray(arr)) {
      // invalid parameter type
      return;
    }
    const objArr = arr.map((innerArr) =>
      !innerArr[1] ? undefined : { [innerArr[0]]: innerArr[1] }
    );
    const params = Object.assign({}, ...objArr);
    return params;
  }
  function reRegisterIfNeeded(key, config, targetConfig) {
    const reRegisterAfterEvent =
      targetConfig.reRegisterAfterEvent ?? config.reRegisterAfterEvent;
    if (
      reRegisterAfterEvent &&
      (typeof reRegisterAfterEvent === "boolean" ||
        Array.isArray(reRegisterAfterEvent))
    ) {
      const keys =
        typeof reRegisterAfterEvent === "boolean"
          ? [key]
          : reRegisterAfterEvent;
      for (const k of keys) {
        setTimeout(() => {
          const _config = CUSTOM_EVENTS[k];
          regiser(k, _config);
        }, [3000]);
        unregister(k);
      }
    }
  }
  /********************
   * START: handlers
   ********************/
  function makeSortCollectionItemsHandler(key, config, targetConfig) {
    return function (event) {
      const value = event.currentTarget.value;
      const params = makeParams([["sort_by", value]]);
      if (DEBUG) {
        console.log("\u001b[32m" + "makeSortCollectionItemsHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeToggleFavoriteHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "toggleFavoriteHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const { state, datasetProductKey, datasetVariantKey } = targetConfig;
      let isAdded;
      if (state?.attr === "class") {
        isAdded = target.classList.contains(state.key.replace(".", ""));
      } else if (state?.attr === "data") {
        isAdded =
          target.dataset[state.key] && target.dataset[state.key] === "true";
      } else if (state?.attr === "aria") {
        isAdded = target.getAttribute(`aria-${state.key}`) === "true";
      }
      const eventName = isAdded ? "sh_remove_favorite" : "sh_add_favorite";
      const productId = target.dataset[datasetProductKey];
      const variantId = target.dataset[datasetVariantKey];
      const params = makeParams([
        ["product_id", productId],
        ["variant_id", variantId],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "toggleFavoriteHandler", eventName, params);
      }
      !DRY_RUN && gtag?.("event", eventName, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeExpandThumbnailHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "expandThumbnailHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const imageEl =
        target instanceof HTMLImageElement
          ? target
          : target.querySelector("img")
          ? target.querySelector("img")
          : target.parentElement?.querySelector(
              targetConfig.activeImgSelector ?? "img"
            );
      const { src, alt } = imageEl ?? {};
      const params = makeParams([
        ["image_url", src],
        ["image_alt", alt],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "expandThumbnailHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }

  function makeSlideThumbnailHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "slideThumbnailHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const allItems = findAllTargetElement(
        targetConfig.selector || config.defaultSelector,
        targetConfig.shadowRootSelector
      );
      const slideNum = Array.from(allItems).indexOf(target);
      const imageEl =
        target instanceof HTMLImageElement
          ? target
          : target.querySelector("img");
      const { src, alt } = imageEl ?? {};
      const params = makeParams([
        ["image_url", src],
        ["image_alt", alt],
        ["slide_num", slideNum],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "slideThumbnailHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeClickReviewLinkHandler(key, config, targetConfig) {
    return function (event) {
      const params = makeParams([]);
      if (DEBUG) {
        console.log("\u001b[32m" + "clickReviewLinkHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }

  function makePaginateReviewsHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "paginateReviewsHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const { datasetPageKey } = targetConfig;
      const page = target.dataset[datasetPageKey];
      if (page === undefined) {
        if (DEBUG) {
          console.error(
            "paginateReviewsHandler:",
            `要素のdatasetに${datasetPageKey}が含まれていません`
          );
        }
        return;
      }
      const params = makeParams([["page", page]]);
      if (DEBUG) {
        console.log("\u001b[32m" + "paginateReviewsHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeSubmitReviewHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      const isFormEl = target instanceof HTMLFormElement;
      if (!isFormEl) {
        if (DEBUG) {
          console.error(
            "submitReviewHandler:",
            "targetSelectorに指定された要素がformではありません"
          );
        }
        return;
      }
      const { ratingFieldName } = targetConfig;
      const formData = new FormData(target);
      const score = formData.get(ratingFieldName);
      if (score === undefined) {
        if (DEBUG) {
          console.error(
            "submitReviewHandler:",
            `formのフィールドに name="score"が存在しません`
          );
        }
        return;
      }
      const params = makeParams([
        ["rating", score],
        ["form_id", target.id],
        ["form_name", target.name],
        ["form_destination", target.action],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "submitReviewHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeSearchReviewHandler(key, config, targetConfig) {
    return function (event) {
      if (
        (event instanceof KeyboardEvent &&
          event.code.toLowerCase() === "enter") ||
        event instanceof FocusEvent
      ) {
        const search = event.target.value.trim();
        const params = makeParams([["search", search]]);
        if (DEBUG) {
          console.log("\u001b[32m" + "makeSearchReviewHandler", params);
        }
        !DRY_RUN && gtag?.("event", key, params);
        reRegisterIfNeeded(key, config, targetConfig);
      }
    };
  }
  function makeSortReviewHandler(key, config, targetConfig) {
    return function (event) {
      const value = event.currentTarget.value;
      const params = makeParams([["sort_by", value]]);
      if (DEBUG) {
        console.log("\u001b[32m" + "makeSortReviewHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeOpenHiddenContentHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "makeOpenHiddenContentHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const { state } = targetConfig;
      let isOpen;
      if (state?.attr === "class") {
        isOpen = target.classList.contains(state.key.replace(".", ""));
      } else if (state?.attr === "data") {
        isOpen =
          target.dataset[state.key] && target.dataset[state.key] === "true";
      } else if (state?.attr === "aria") {
        isOpen = target.getAttribute(`aria-${state.key}`) === "true";
      }
      if (isOpen) return;
      const position = measureElementScrollPosition(target);
      const innerText = getInnerContent(target);
      const params = makeParams([
        ["inner_text", innerText],
        ["scroll_offset", position],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "makeOpenHiddenContentHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeLaunchChatHandler(key, config, targetConfig) {
    return function (event) {
      const { state } = targetConfig;
      const target = event.currentTarget;
      let isOpen;
      if (state?.attr === "class") {
        isOpen = target.classList.contains(state.key.replace(".", ""));
      } else if (state?.attr === "data") {
        isOpen =
          target.dataset[state.key] && target.dataset[state.key] === "true";
      } else if (state?.attr === "aria") {
        isOpen = target.getAttribute(`aria-${state.key}`) === "true";
      }
      if (isOpen) return;
      const params = makeParams([]);
      if (DEBUG) {
        console.log("\u001b[32m" + "launchChatHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeSubscribeEmailHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      const formEl =
        target instanceof HTMLFormElement ? target : target.closest("form");
      if (!formEl) {
        if (DEBUG) {
          console.error(
            "subscribeEmailHandler:",
            "targetSelectorに指定された要素がformまたはformの孫要素ではありません"
          );
        }
        return;
      }
      const params = makeParams([
        ["form_id", formEl.id],
        ["form_name", formEl.name],
        ["form_destination", formEl.action],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "subscribeEmailHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeClickCTAHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      const isButtonOrAnchorEl =
        target instanceof HTMLButtonElement ||
        target instanceof HTMLAnchorElement;
      if (!isButtonOrAnchorEl) {
        if (DEBUG) {
          console.error(
            "clickCTAHandler:",
            "targetSelectorに指定された要素がa, buttonのいずれでもありません"
          );
        }
        return;
      }
      const innerText = getInnerContent(target);
      const position = measureElementScrollPosition(target);
      const label = targetConfig.label;
      const params = makeParams([
        ["inner_text", innerText],
        ["scroll_offset", position],
        ["cta_label", label],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "clickCTAHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeSubmitCTAHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      const isFormEl = target instanceof HTMLFormElement;
      if (!isFormEl) {
        if (DEBUG) {
          console.error(
            "clickCTAHandler:",
            "targetSelectorに指定された要素がformではありません"
          );
        }
        return;
      }
      const position = measureElementScrollPosition(target);
      const label = targetConfig.label;
      const params = makeParams([
        ["form_id", target.id],
        ["form_name", target.name],
        ["form_destination", target.action],
        ["scroll_offset", position],
        ["cta_label", label],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "submitCTAHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeClickImageOnReviewHandler(key, config, targetConfig) {
    return function (event) {
      const target = event.currentTarget;
      if (!target) {
        if (DEBUG) {
          console.error(
            "clickImageOnReviewHandler:",
            "event.currentTargetが見つかりません"
          );
        }
        return;
      }
      const imageEl =
        target instanceof HTMLImageElement
          ? target
          : target.querySelector("img");
      const { src, alt } = imageEl ?? {};
      const params = makeParams([
        ["image_url", src],
        ["image_alt", alt],
      ]);
      if (DEBUG) {
        console.log("\u001b[32m" + "clickImageOnReviewHandler", params);
      }
      !DRY_RUN && gtag?.("event", key, params);
      reRegisterIfNeeded(key, config, targetConfig);
    };
  }
  function makeScrollPageHandler(key, config) {
    let lastKnownScrollPosition = 0;
    let ticking = false;
    const negativeMargin = -1;
    const scrolledCaptures = {};
    return function () {
      const customEventKey = "sh_scroll_page";
      lastKnownScrollPosition = window.scrollY;
      if (ticking) return;
      window.requestAnimationFrame(() => {
        const documentHeight =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight +
          negativeMargin;
        const scroll = documentHeight
          ? Math.floor((lastKnownScrollPosition / documentHeight) * 100)
          : 0;
        const captureIndex = Math.floor(scroll / 25);
        if (captureIndex > 0 && !scrolledCaptures[captureIndex]) {
          const params = makeParams([["percent_scrolled", captureIndex * 25]]);
          if (DEBUG) {
            console.log("\u001b[32m" + "scrollPageHandler", params);
          }
          !DRY_RUN && gtag?.("event", customEventKey, params);
          scrolledCaptures[captureIndex] = true;
        }
        ticking = false;
      });
      ticking = true;
    };
  }

  /********************
   * END: handlers
   ********************/

  function _registerEventToTarget(key, config, targetConfig) {
    const { registerAfterEvent, ...rest } = targetConfig;
    if (
      registerAfterEvent &&
      typeof registerAfterEvent.selector === "string" &&
      !!registerAfterEvent.selector &&
      typeof registerAfterEvent.nativeEvent == "string" &&
      !!registerAfterEvent.nativeEvent
    ) {
      const elements = document.querySelectorAll(registerAfterEvent.selector);
      if (!elements.length) return false;
      const callback = function () {
        _registerEventToTarget(key, config, rest);
      };
      elements.forEach((el) => {
        el.addEventListener(registerAfterEvent.nativeEvent, callback);
        registeredHandlers.set(key, [
          ...prev,
          [el, registerAfterEvent.nativeEvent, callback],
        ]);
      });
      return true;
    }

    const selector =
      targetConfig.shadowRootSelector ||
      targetConfig.selector ||
      config.defaultSelector;
    if (!selector) return false;
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return false;
    elements.forEach((el) => {
      const _el =
        !!targetConfig.shadowRootSelector &&
        "shadowRoot" in el &&
        !!el.shadowRoot
          ? el.shadowRoot.querySelector(targetConfig.selector)
          : el;
      if (!_el) return;
      const callback = config.getCallback(key, config, targetConfig);
      const nativeEvent = targetConfig.nativeEvent ?? config.nativeEvent;
      if (!nativeEvent) return;
      const nativeEvents = Array.isArray(nativeEvent)
        ? nativeEvent
        : [nativeEvent];
      for (const ne of nativeEvents) {
        _el.addEventListener(ne, callback, {
          capture: true,
          once: targetConfig.once ?? config.once ?? false,
          passive: true,
        });
        if (DEBUG) {
          console.log(
            "\u001b[34m" + `(selector: ${selector}) Registered ${ne} event to`,
            _el
          );
        }
        const prev = registeredHandlers.get(key) ?? [];
        registeredHandlers.set(key, [...prev, [_el, ne, callback]]);
      }
    });
    return true;
  }

  function observeMount(key, config, targetConfig, parentSelector) {
    const container = document.querySelector(parentSelector);
    if (!container) return;
    let once = false;
    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          if (!once) {
            const ok = _registerEventToTarget(key, config, targetConfig);
            if (ok) {
              once = true;
              observer.disconnect();
            }
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }
  function regiser(key, config) {
    if (config.nativeEvent === "scroll") {
      const callback = config.getCallback(key, config);
      window.addEventListener("scroll", callback);
      const prev = registeredHandlers.get(key) ?? [];
      registeredHandlers.set(key, [...prev, [window, "scroll", callback]]);
    } else {
      for (const targetConfig of config.targets) {
        const delay = targetConfig.delay ?? config.delay;
        function _exec(key, config, targetConfig) {
          const s = targetConfig.observeMount ?? config.observeMount;
          if (s) {
            observeMount(key, config, targetConfig, s);
          } else {
            _registerEventToTarget(key, config, targetConfig);
          }
        }
        if (typeof delay === "number") {
          setTimeout(() => _exec(key, config, targetConfig), delay);
        } else {
          _exec(key, config, targetConfig);
        }
      }
    }
  }
  function unregister(key) {
    const handlers = registeredHandlers.get(key) ?? [];
    for (const [el, eventType, handler] of handlers) {
      el.removeEventListener(eventType, handler);
      registeredHandlers.set(key, []);
    }
  }
  function init() {
    const eventKeys = Object.keys(CUSTOM_EVENTS);
    for (const key of eventKeys) {
      const config = CUSTOM_EVENTS[key];
      regiser(key, config);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
